import React from "react";

function Footer() {
  return (
    <footer className="footer-custom">
      <div className="container">
        <div className="row text-center text-md-start">

          {/* Logo + About */}
          <div className="col-lg-4 col-md-12 mb-4">
            <h3 className="footer-logo">
              <span className="me-2">
                <i className="fa-solid fa-school"></i>
              </span>
              uniformNX
            </h3>

            <p className="footer-text">
              Premium school commerce platform connecting institutions with families.
            </p>

            {/* Social Icons */}
            <div className="social-icons">
              <a href="#"><i className="fa-brands fa-twitter"></i></a>
              <a href="#"><i className="fa-brands fa-facebook"></i></a>
              <a href="#"><i className="fa-brands fa-instagram"></i></a>
              <a href="#"><i className="fa-brands fa-linkedin"></i></a>
            </div>
          </div>

          {/* Support */}
          <div className="col-lg-2 col-md-6 col-6 mb-4">
            <h5>Support</h5>
            <ul className="footer-links">
              <li><a href="/help-center">Help Center</a></li>
              <li><a href="/return">Returns</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-lg-2 col-md-6 col-6 mb-4">
            <h5>Legal</h5>
            <ul className="footer-links">
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/termsofservice">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <hr />

        {/* Bottom Section */}
        <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <p>© 2026 EduSupply. All rights uniformnx</p>
          <p>Secure SSL Encryption</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;